<template>
    <b-card class="shadow" style="min-height: 700px" ref="printMe">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Gráficos Equipe SUAS") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-md-12">
                <div class="col-12">
                    <p>
                        Período de pesquisa selecionado:
                        <b>{{ report.datas.start }} - {{ report.datas.end }}</b>
                        <b-link
                            href="#"
                            @click.prevent="void 0"
                            class="mb-2"
                            variant="info"
                            v-b-popover.hover.top="
                                'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                            "
                        >
                            <i class="fas fa-info-circle"></i>
                        </b-link>
                    </p>
                </div>
                <div class="col-12 no-print" v-if="viewFilterReport">
                    <!-- Filtros -->
                    <form @submit.prevent="getAnalytics" ref="addItem">
                        <div class="row">
                            <form-calendar
                                v-model="data_inicio"
                                grid="6"
                                label="Data Inicial"
                            />

                            <form-calendar
                                v-model="data_fim"
                                grid="6"
                                label="Data final"
                                :required="verificaDataInicial"
                                :min-date="data_inicio"
                            />
                        </div>
                        <div
                            class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                            <div class="col-auto px-2 text-right">
                                <button
                                    class="btn btn-default"
                                    @click.prevent="
                                        limparFiltros(),
                                            (viewFilterReport = false)
                                    "
                                >
                                    <i class="fas fa-times"></i>
                                </button>

                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    @click.prevent="limparFiltros()"
                                >
                                    {{ $t("Limpar Filtros") }}
                                </button>

                                <button
                                    class="btn btn-success btn-submit"
                                    data-style="zoom-in"
                                    type="submit"
                                >
                                    <i class="fas fa-chart-bar"></i>
                                    {{ $t("Gerar Gráfico") }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="col-12" id="boxPrint">
                <b-tabs content-class="mt-3">
                    <b-tab
                        title="Por Unidades"
                        @click.prevent="changeTab('Por Unidades')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Unidades'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />
                                <span v-if="report.por_unidades.length == 0">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <bar-chart
                                    v-else
                                    :data="report.por_unidades"
                                ></bar-chart>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Por Sexo"
                        @click.prevent="changeTab('Por Sexo')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Sexo'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />
                                <span v-if="report.por_sexo.length == 0">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <div
                                    class="col-md-12"
                                    style="min-height: 700px"
                                    v-else
                                >
                                    <donut-graph
                                        :loading="loading"
                                        :data="report.por_sexo"
                                        :range="range"
                                    />
                                </div>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Por Status"
                        @click.prevent="changeTab('Por Status')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Status'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />
                                <span v-if="report.por_status.length == 0">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <pie-chart
                                    v-else
                                    :donut="true"
                                    :data="report.por_status"
                                    height="600px"
                                ></pie-chart>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab
                        title="Por Função"
                        @click.prevent="changeTab('Por Função')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Função'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span v-if="report.por_funcoes.length == 0">
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <bar-chart
                                    v-else
                                    :data="report.por_funcoes"
                                ></bar-chart>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab
                        title="Por Carga Horária"
                        @click.prevent="changeTab('Por Carga Horária')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Carga Horária'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="report.por_carga_horaria.length == 0"
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <pie-chart
                                    v-else
                                    :donut="true"
                                    :data="report.por_carga_horaria"
                                    height="600px"
                                ></pie-chart>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab
                        title="Por Escolaridade"
                        @click.prevent="changeTab('Por Escolaridade')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Escolaridade'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="report.por_escolaridade.length == 0"
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <bar-chart
                                    v-else
                                    :data="report.por_escolaridade"
                                ></bar-chart>
                            </div>
                        </div>
                    </b-tab>

                    <b-tab
                        title="Por Regime de Trabalho"
                        @click.prevent="changeTab('Por Regime de Trabalho')"
                    >
                        <div class="row">
                            <div
                                class="col-md-12"
                                v-if="tabAtiva == 'Por Regime de Trabalho'"
                            >
                                <loading-animation
                                    :active.sync="loading"
                                    :is-full-page="false"
                                    :opacity="1"
                                    color="#5895FF"
                                />

                                <span
                                    v-if="
                                        report.por_regime_trabalho.length == 0
                                    "
                                >
                                    <div
                                        class="row align-items-center text-center empty-graph"
                                    >
                                        <div class="col">
                                            <img
                                                :alt="$t('No results')"
                                                class="mb-3"
                                                src="/img/graphics/statistic_chart.svg"
                                                style="max-height: 100px"
                                            />
                                            <h5>
                                                {{ $t("No records available") }}
                                            </h5>
                                        </div>
                                    </div>
                                </span>
                                <pie-chart
                                    v-else
                                    :donut="true"
                                    :data="report.por_regime_trabalho"
                                    height="600px"
                                ></pie-chart>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
            <div class="col-md-12 text-center mt-3">
                <b-button
                    :title="$t('Imprimir')"
                    class="py-2"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                    @click="printHtml()"
                >
                    <i class="fas fa-print"></i>
                </b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "EquipeTecnicaGraficos",
    data() {
        return {
            loading: true,
            report: {
                por_status: [],
                por_funcoes: [],
                por_unidades: [],
                por_carga_horaria: [],
                por_escolaridade: [],
                por_regime_trabalho: [],
                datas: {
                    start: "",
                    end: "",
                },
            },
            range: null,
            filtros: {},
            tabAtiva: "Por Unidades",
        };
    },
    mounted() {
        this.getAnalytics();
    },

    methods: {
        changeTab(value) {
            if (value) {
                this.tabAtiva = value;
            } else {
                this.tabAtiva = "Por Unidades";
            }
            this.getAnalytics();
        },
        updateAnalytics(range) {
            if (this.range !== range) {
                this.range = range;
                this.getAnalytics();
            }
        },
        getAnalytics() {
            if (this.data_inicio) {
                this.filtros.data_inicial = this.$options.filters.formatDateYMD(
                    this.data_inicio
                );
            }
            if (this.data_fim) {
                this.filtros.data_final = this.$options.filters.formatDateYMD(
                    this.data_fim
                );
            }

            this.loading = true;
            const tab = { tab: this.tabAtiva };
            axios
                .get("api/dashboard/report/tecnicos/graficos", {
                    params: {
                        range: this.range,
                        filtros: this.filtros,
                        ...tab,
                    },
                })
                .then((response) => {
                    this.report = response.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        limparFiltros() {
            this.filtros.data_inicial = null;
            this.filtros.data_final = null;
            this.data_inicio = null;
            this.data_fim = null;
            this.getAnalytics();
        },
    },
};
</script>
